/**
 * exatrek REST API
 * Some custom description of API.
 *
 * The version of the OpenAPI document: v3
 * Contact: dev@exatrek.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CombinationDto } from './combinationDto';
import { ImplementDataDto } from './implementDataDto';
import { TaskIdDto } from './taskIdDto';
import { GeometryIdDto } from './geometryIdDto';
import { EmployeeDataDto } from './employeeDataDto';
import { EmployeeIdDto } from './employeeIdDto';
import { MachineDataDto } from './machineDataDto';
import { EnterpriseIdDto } from './enterpriseIdDto';

export interface JobV2Dto {
  combination?: CombinationDto;
  employee?: EmployeeIdDto;
  employeeData?: EmployeeDataDto;
  geometry?: GeometryIdDto;
  id?: number;
  implementPrimaryData?: ImplementDataDto;
  implementSecondaryData?: ImplementDataDto;
  machineData?: MachineDataDto;
  owner?: EnterpriseIdDto;
  resource?: string;
  start?: string;
  state?: string;
  stop?: string;
  task?: TaskIdDto;
  vehicleHoursStart?: number;
  vehicleHoursStop?: number;
  vehicleMileageStart?: number;
  vehicleMileageStop?: number;
}
